import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

function AiSearchSummary({ aiMatch, chips = [], onEdit, onContinue, onUndo }) {
    if (!aiMatch?.active) return null;

    const criteria = aiMatch.criteria || {};
    const features = [...(criteria.amenities || []), ...(criteria.geo_features || [])];
    const requiredCount = features.filter(item => item.required).length;
    const preferredCount = features.filter(item => !item.required).length;
    const shown = aiMatch.results.length;
    const total = aiMatch.total;

    return (
        <section className="ai-search-summary" aria-label="خلاصه جستجوی هوشمند">
            <div className="ai-summary-heading">
                <span className="ai-summary-icon"><AutoAwesomeIcon fontSize="small" /></span>
                <div>
                    <strong>جستجوی هوشمند فعال است</strong>
                    <p>
                        {shown.toLocaleString('fa-IR')} نتیجه رتبه‌بندی‌شده
                        {total > shown ? ` از ${total.toLocaleString('fa-IR')} تطابق` : ''}
                    </p>
                </div>
            </div>

            {chips.length > 0 && (
                <div className="ai-summary-chips" aria-label="معیارهای اعمال‌شده">
                    {chips.slice(0, 6).map(chip => <span key={chip.key}>{chip.label}</span>)}
                    {chips.length > 6 && <span>+{(chips.length - 6).toLocaleString('fa-IR')}</span>}
                </div>
            )}

            {(requiredCount > 0 || preferredCount > 0) && (
                <p className="ai-summary-meta">
                    {requiredCount > 0 && `${requiredCount.toLocaleString('fa-IR')} الزام`}
                    {requiredCount > 0 && preferredCount > 0 && ' · '}
                    {preferredCount > 0 && `${preferredCount.toLocaleString('fa-IR')} ترجیح برای رتبه‌بندی`}
                </p>
            )}

            <div className="ai-summary-actions">
                <button type="button" onClick={onEdit}>ویرایش فیلترها</button>
                <button type="button" onClick={onContinue}>ادامه با دستیار</button>
                <button type="button" className="secondary" onClick={onUndo}>بازگشت</button>
            </div>
        </section>
    );
}

export default AiSearchSummary;
